import { render, staticRenderFns } from "./RiskCheckDailySafetyChecklistDetail.vue?vue&type=template&id=dd15583a&scoped=true"
import script from "./RiskCheckDailySafetyChecklistDetail.vue?vue&type=script&lang=js"
export * from "./RiskCheckDailySafetyChecklistDetail.vue?vue&type=script&lang=js"
import style0 from "./RiskCheckDailySafetyChecklistDetail.vue?vue&type=style&index=0&id=dd15583a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd15583a",
  null
  
)

export default component.exports